import React, { useState, useContext } from 'react';
import { Authentication } from '../../App'
import axios from "axios";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import { Container, Typography } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import DownloadIcon from '@mui/icons-material/Download';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import TextField from '@mui/material/TextField';
import ja from 'date-fns/locale/ja'
// import { useDropzone } from 'react-dropzone';
import Dropzone from 'react-dropzone';

import './Css/StampPut.css'

import Stamp from '../Stamp/Index.js';

import PinkStamp from '../../img/pinkStamp.png';
import BlueStamp from '../../img/blueStamp.png';
import GreenStamp from '../../img/greenStamp.png';
import RedStamp from '../../img/redStamp.png';
import YellowStamp from '../../img/yellowStamp.png';
import PurpleStamp from '../../img/purpleStamp.png';
import moment from 'moment';
import { CSVLink, CSVDownload } from "react-csv";
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
moment.locale("ja", {
  weekdays: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"],
  weekdaysShort: ["日", "月", "火", "水", "木", "金", "土"]
});


function StampPut() {
  const theme = createTheme({
    palette: {
      neutral: {
        main: '#357ebd',
        contrastText: '#fff',
      },
      put_button: {
        main: "#5CB85C",
        contrastText: '#fff',
      }
    },
  });
  const authentication = useContext(Authentication);

  const today = new Date();
  const [value, setValue] = useState(today);
  const [SectionList, setSectionList] = useState();
  const [UserList, setUserList] = useState([]);
  const [Section, setSection] = useState();
  const [User, setUser] = useState();
  const [stamps, setStamps] = useState([]);
  const [Dates, setDates] = useState(today);
  const [stamp, setStamp] = useState();
  const [Category, setCategory] = useState();
  const [TrainingList, setTrainingList] = useState([]);
  const [Training, setTraining] = useState();
  const [loading, setLoading] = useState(false);//検索中
  const [userId, setuserId] = useState();
  const [Point, setPoint] = useState();
  const [file, setfile] = useState();
  const [fileName, setfileName] = useState("");
  const [StampSheets, setStampSheets] = useState([]);
  const [Csv, setCsv] = useState();

  const handleChange = (newValue) => {
    setValue(newValue)
  }

  // const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
  // const files = acceptedFiles.map(file => {
  //   // console.log(file);
  //   // console.log(typeof(file));
  //   var blobUrl = window.URL.createObjectURL(file);
  //   return <img src={blobUrl} alt={'img_url'} width={80} />
  // });

  const [visible, setVisible] = useState(false);
  const stampNumOn = () => {
    setVisible(true);
  }
  const stampNumOff = () => {
    setVisible(false);
  }

  const selectstamp = (data) => {
    setStamp(data);
  }

  const download = (id) => {
    // let url = `http://localhost:5000/v1/training/files/get_file/` + id;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/training/files/get_file/` + id;

    axios.get(url).then((r) => {
      // console.log(r.data);
      r.data.forEach(e => {
        // let url2 = `http://localhost:5000/v1/training/files/download/` + e.name;
        let url2 = process.env.REACT_APP_API_BASE_URL + `/v1/training/files/download/` + e.name;

        axios.get(url2).then((file) => {
          const a = document.createElement('a');
          a.download = e.name;
          a.href = file.config.url;
          a.click();
        });
      });
    });
  }

  const category = (data) => {
    setCategory(data);
    // let url = `http://localhost:5000/v1/training/events/search`;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/training/events/search`;

    axios.post(url, {
      syanai: data == 1 ? true : false,
      syagai: data == 2 ? true : false,
      tsushin: data == 3 ? true : false,
      tosyo: data == 4 ? true : false,
    }).then((abc) => {
      console.log(abc.data);
      setTrainingList(JSON.parse(JSON.stringify(abc.data)));
    });
  }


  const csv = () => {
    // let url = `http://localhost:5000/v1/training/points/csv`;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/training/points/csv`;
    axios.post(url, {
      section_id: Section
    }).then((abc) => {
      setCsv(abc.data);
    });
  }

  const section = (data) => {
    setSection(data);
    // let url = `http://localhost:5000/v1/users/section/` + data;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/users/section/` + data;

    axios.get(url).then((abc) => {
      setUserList(abc.data)

      let url2 = process.env.REACT_APP_API_BASE_URL + `/v1/training/points/csv`;
      axios.post(url2, {
        section_id: data
      }).then((abc) => {
        setCsv(abc.data);
      });
    });
  }
  const user = (data) => {
    setUser(data);
    // let url = `http://localhost:5000/v1/training/points/my_point/` + data;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/training/points/my_point/` + data;
    axios.get(url).then((abc) => {
      setStamps(abc.data.stamps)
      setStampSheets(abc.data.stamp_sheets)
    });
  }

  const sendstamp = () => {
    setLoading(true);
    if (!Training) {
      alert("研修が選択されていません");
      return;
    }
    if (!User) {
      alert("社員が選択されていません");
      return;
    }
    if (!stamp) {
      alert("スタンプが選択されていません");
      return;
    }
    if (!Point) {
      alert("ポイントが選択されていません");
      return;
    }
    if (!file) {
      if (stamp !== 2 && stamp !== 3 && stamp !== 4) {
        alert("ファイルが添付されていません");
        return;
      }
    }


    // let url = `http://localhost:5000/v1/training/points/insert`;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/training/points/insert`;

    axios.post(url, {
      training_events_id: Training,
      user_id: User,
      created_at: new Date(),
      created_user_id: userId,
      training_m_stamps_id: stamp,
      point: Point,
      grant_at: Dates
    }).then((abc) => {
      var i = 1;
      file.forEach(e => {
        // let url2 = `http://localhost:5000/v1/training/files/upload_file/` + abc.data.id + "/" + userId + "/" + i;
        let url2 = process.env.REACT_APP_API_BASE_URL + `/v1/training/files/upload_file/` + abc.data.id + "/" + userId + "/" + i;

        i++;
        const token = authentication.getAccessToken();
        var formData = new FormData();
        formData.append("files", e);
        fetch(url2, {
          method: 'post',
          body: formData,
          headers: { 'Authorization': 'Bearer ' + token },
        })
          .then(() => {
            setLoading(false)
          });
      });
      alert("スタンプを付与しました");

      // let url2 = `http://localhost:5000/v1/training/points/my_point/` + User;
      let url2 = process.env.REACT_APP_API_BASE_URL + `/v1/training/points/my_point/` + User;

      axios.get(url2).then((abc) => {
        setStamps(abc.data.stamps)
        setStampSheets(abc.data.stamp_sheets)
        setfile();
        setfileName();
      });
    });
  }

  const deletestamp = (id) => {
    var result = window.confirm('スタンプを削除します。よろしいですか？');
    if (result) {
      // let url = `http://localhost:5000/v1/training/points/delete`;
      let url = process.env.REACT_APP_API_BASE_URL + `/v1/training/points/delete`;

      axios.post(url, {
        id: id
      }).then((abc) => {
        alert("スタンプを削除しました");
        // let url2 = `http://localhost:5000/v1/training/points/my_point/` + User;
        let url2 = process.env.REACT_APP_API_BASE_URL + `/v1/training/points/my_point/` + User;

        axios.get(url2).then((abc) => {
          setStamps(abc.data.stamps)
          setStampSheets(abc.data.stamp_sheets)

        });
        setLoading(false)
      });
    }
  }

  const onDrop = (files) => {
    setfile(files);
    var filename = "";
    var i = 0;
    files.forEach(e => {
      if (i == 0) {
        filename = e.name;
      } else {
        filename = filename + "," + e.name;
      }
      i++;
      setfileName(filename);

    });
  }



  React.useEffect(() => {
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/training/events/search`;
    axios.post(url, {
      syanai: true,
      syagai: true,
      tsushin: true,
      tosyo: true 
    }).then((abc) => {
      setTrainingList(JSON.parse(JSON.stringify(abc.data)));
    });
  }, []);
  React.useEffect(() => {
    // let url = `http://localhost:5000/v1/training/points/csv`;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/training/points/csv`;
    axios.post(url).then((abc) => {
      setCsv(abc.data);
    });
  }, []);
  React.useEffect(() => {
    // let url = `http://localhost:5000/v1/users/detail`;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/users/detail`;

    axios.get(url, { headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } }).then((response) => {
      setuserId(response.data.id)
    });
  }, []);

  React.useEffect(() => {
    // let url = `http://localhost:5000/v1/tm/tenpo/list`;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/tm/tenpo/list`;

    axios.get(url).then((abc) => {
      setSectionList(abc.data)
    });
  }, []);
  if (!SectionList) return null;

  return (
    <Box className="App" id="content" style={{ paddingTop: 60 }}>
      <Grid container sx={{ justifyContent: 'center', mt: 0 }}>
        <Grid item xs={4.5} sx={{ backgroundColor: 'white', borderRadius: 1, mr: 1, pt: 3, pl: 2, pr: 2, pb: 2 }}>
          <Container sx={{ display: 'inline-flex', justifyContent: 'space-between' }}>
            <Typography sx={{ fontSize: 28, fontWeight: 'bold' }} gutterBottom>スタンプ付与</Typography>
            <FormControl sx={{ width: 200 }}>
              <InputLabel id="demo-simple-select-label">期間</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                defaultValue={1}
                label="期間"
                size='small'
              >
                <MenuItem value={1}>2023年(4月～12月)</MenuItem>
              </Select>
            </FormControl>
          </Container>
          <Container sx={{ display: 'inline-flex', mt: 3 }}>
            <Typography sx={{ mt: 'auto', mb: 'auto', width: 150, textAlign: 'left' }}>部署</Typography>
            <FormControl sx={{ width: 200, textAlign: 'left' }}>
              {/* <InputLabel id="demo-simple-select-label">部署</InputLabel> */}
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                size='small'
                onChange={(e) => { section(e.target.value) }}
              >
                {SectionList.map(function (i) {
                  return <MenuItem value={i.Tenpo_No}>{i.Tenpo_Name}</MenuItem>
                }, this)}
              </Select>
            </FormControl>
            <ThemeProvider theme={theme}>
              {Csv ?
                <Button variant="contained" size='small' sx={{ ml: 2 }}>
                  <CSVLink style={{ textDecoration: "none", color: "white" }} filename="stamp.csv" data={Csv}>集計表出力</CSVLink></Button> : ""}
            </ThemeProvider>
          </Container>
          <Container sx={{ display: 'inline-flex', mt: 2 }}>
            <Typography sx={{ mt: 'auto', mb: 'auto', width: 150, textAlign: 'left' }}>名前</Typography>
            <FormControl sx={{ width: 200, textAlign: 'left' }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                size='small'
                onChange={(e) => { user(e.target.value) }}
              >
                {UserList.map(function (i) {
                  return <MenuItem value={i.id}>{i.user_name_all}</MenuItem>
                }, this)}
              </Select>
            </FormControl>
          </Container>
          <Container sx={{ display: 'inline-flex', mt: 2 }}>
            <Typography sx={{ mt: 'auto', mb: 'auto', width: 150, textAlign: 'left' }}>付与日</Typography>
            <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
              <DatePicker
                // label="付与日"
                value={Dates}
                onChange={(e) => { setDates(e) }}
                inputFormat='yyyy年MM月dd日'
                mask='____年__月__日'
                renderInput={(params) => <TextField size='small' {...params} sx={{ width: 200 }} />}
              />
            </LocalizationProvider>
          </Container>
          <Typography sx={{ textAlign: 'left', ml: 3, mt: 2 }}>付与するスタンプ</Typography>
          <Container style={{ paddingLeft: 14, paddingRight: 14 }} sx={{ display: 'inline-flex', mb: 2 }}>
            <Button sx={{ background: stamp == 1 ? "#b0c4de" : "", p: 0, textTransform: 'none' }} onClick={() => (selectstamp(1))}>
              <Container style={{ padding: 0 }}>
                <img src={PinkStamp} alt="pink_stamp" width={'100%'} />
                <Typography sx={{ fontSize: 12, color: 'black' }}>通信講座終了</Typography>
                <Typography sx={{ fontSize: 12, color: 'black', mt: 3 }}>開催期間月数pt</Typography>
              </Container>
            </Button>
            <Button sx={{ background: stamp == 2 ? "#b0c4de" : "", p: 0, textTransform: 'none' }} onClick={() => (selectstamp(2), setPoint(5), setfileName(), setfile())}>
              <Container style={{ padding: 0 }}>
                <img src={BlueStamp} alt="blue_stamp" width={'100%'} />
                <Typography sx={{ fontSize: 12, color: 'black' }}>通信講座終了後<br />社内研修実施</Typography>
                <Typography sx={{ fontSize: 14, color: 'black', mt: 0.8 }}>5pt</Typography>
              </Container>
            </Button>
            <Button sx={{ background: stamp == 3 ? "#b0c4de" : "", p: 0, textTransform: 'none' }} onClick={() => (selectstamp(3), setPoint(5), setfileName(), setfile())}>
              <Container style={{ padding: 0 }}>
                <img src={GreenStamp} alt="green_stamp" width={'100%'} />
                <Typography sx={{ fontSize: 12, color: 'black' }}>社外研修受講後<br />社内研修実施</Typography>
                <Typography sx={{ fontSize: 14, color: 'black', mt: 0.8 }}>5pt</Typography>
              </Container>
            </Button>
            <Button sx={{ background: stamp == 4 ? "#b0c4de" : "", p: 0, textTransform: 'none' }} onClick={() => (selectstamp(4), setPoint(5), setfileName(), setfile())}>
              <Container style={{ padding: 0 }}>
                <img src={RedStamp} alt="red_stamp" width={'100%'} />
                <Typography sx={{ fontSize: 12, color: 'black' }}>得意分野の<br />社内研修実施</Typography>
                <Typography sx={{ fontSize: 14, color: 'black', mt: 0.8 }}>5pt</Typography>
              </Container>
            </Button>
            <Button sx={{ background: stamp == 5 ? "#b0c4de" : "", p: 0, textTransform: 'none' }} onClick={() => (selectstamp(5), setPoint(1))}>
              <Container style={{ padding: 0 }}>
                <img src={YellowStamp} alt="yellow_stamp" width={'100%'} />
                <Typography sx={{ fontSize: 12, color: 'black' }}>研修受講<br />報告書提出</Typography>
                <Typography sx={{ fontSize: 14, color: 'black', mt: 0.8 }}>1pt</Typography>
              </Container>
            </Button>
            <Button sx={{ background: stamp == 6 ? "#b0c4de" : "", p: 0, textTransform: 'none' }} onClick={() => (selectstamp(6), setPoint(2))}>
              <Container style={{ padding: 0 }}>
                <img src={PurpleStamp} alt="purple_stamp" width={'100%'} />
                <Typography sx={{ fontSize: 12, color: 'black' }}>推薦図書<br />感想文提出</Typography>
                <Typography sx={{ fontSize: 14, color: 'black', mt: 0.8 }}>2pt</Typography>
              </Container>
            </Button>
          </Container>
          {stamp == 1 ?
            <Container sx={{ display: 'inline-flex', mt: 2 }}>
              <Typography sx={{ mt: 'auto', mb: 'auto', width: 150, textAlign: 'left' }}>スタンプ個数</Typography>
              <FormControl sx={{ width: 200 }}>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  // value={num}
                  // defaultValue={2}
                  // label="スタンプ個数"
                  // onChange={handleChange}
                  size='small'
                >
                  <MenuItem value={1} onClick={() => (setPoint(1))}>1</MenuItem>
                  <MenuItem value={2} onClick={() => (setPoint(2))}>2</MenuItem>
                  <MenuItem value={3} onClick={() => (setPoint(3))}>3</MenuItem>
                  <MenuItem value={4} onClick={() => (setPoint(4))}>4</MenuItem>
                  <MenuItem value={5} onClick={() => (setPoint(5))}>5</MenuItem>
                  <MenuItem value={6} onClick={() => (setPoint(6))}>6</MenuItem>
                  <MenuItem value={7} onClick={() => (setPoint(7))}>7</MenuItem>
                  <MenuItem value={8} onClick={() => (setPoint(8))}>8</MenuItem>
                  <MenuItem value={9} onClick={() => (setPoint(9))}>9</MenuItem>
                  <MenuItem value={10} onClick={() => (setPoint(10))}>10</MenuItem>

                </Select>
              </FormControl>
            </Container>
            : ""}
          {stamp !== 2 && stamp !== 3 && stamp !== 4 ? <Container sx={{ display: 'inline-flex', mt: 2 }}>
            <Typography sx={{ mt: 'auto', mb: 'auto', width: 150, textAlign: 'left' }}>添付</Typography>
            {fileName ? <div>{fileName}
              <IconButton onClick={() => (setfileName(), setfile())}>
                <HighlightOffIcon style={{ marginLeft: 10 }} />
              </IconButton></div> :
              <Dropzone
                onDrop={onDrop}
              >
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps({ className: 'dropzone' })} style={{ background: "#f5f5f5", height: 60, border: "solid" }}>
                    <input {...getInputProps()} />
                    <div>
                      <p>クリックまたはドラッグでファイルをアップロード</p>
                      <ul style={{ padding: 0, marginTop: 3 }}  >
                      </ul>
                    </div>
                  </div>
                )}
              </Dropzone>}
          </Container> : ""}
          {/* <Container sx={{ display: 'inline-flex', mt: 2 }}>
            <Typography sx={{ mt: 'auto', mb: 'auto', width: 150, textAlign: 'left' }}>カテゴリ</Typography>
            <FormControl sx={{ width: 200, textAlign: 'left' }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                // value={category}
                // defaultValue={2}
                // label="カテゴリ"
                // onChange={handleChange}
                size='small'
              >
                <MenuItem value={3} onClick={() => (category(3))}>通信講座</MenuItem>
                <MenuItem value={1} onClick={() => (category(1))}>社内研修</MenuItem>
                <MenuItem value={2} onClick={() => (category(2))}>社外研修</MenuItem>
                <MenuItem value={4} onClick={() => (category(4))}>推薦図書</MenuItem>
              </Select>
            </FormControl>
          </Container> */}
          <Container sx={{ display: 'inline-flex', mt: 2 }}>
            <Typography sx={{ mt: 'auto', mb: 'auto', width: 150, textAlign: 'left' }}>タイトル</Typography>
            <FormControl sx={{ width: 300, textAlign: 'left' }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                // value={title}
                // defaultValue={2}
                // label="タイトル"
                // onChange={handleChange}
                size='small'
              >
                {TrainingList.map(function (i) {
                  return <MenuItem onClick={() => setTraining(i.e_id)} value={i.e_id}>{i.title}</MenuItem>
                }, this)}
              </Select>
            </FormControl>
          </Container>
          <Container sx={{ mt: 3 }}>
            <ThemeProvider theme={theme}>
              <Button color="put_button" variant="contained" onClick={sendstamp}>
                スタンプ付与
              </Button>
            </ThemeProvider>
          </Container>
        </Grid>
        <Grid item xs={7.2} sx={{ backgroundColor: '#F4EBC3', borderRadius: 1, pl: 7, pr: 7 }}>
          <Grid container className='grid_scroll2' sx={{ mt: 5, justifyContent: 'center' }}>
            {[...Array(30)].map(function (v, i) {
              return <Grid item md={2.4} xs={6} sx={{ position: 'relative' }}>
                <Box sx={{ backgroundColor: 'white', width: 150, height: 150, mt: 3 }}>
                  <Typography sx={{ color: 'gray', fontSize: 26, textAlign: 'left', ml: 1 }}>{i + 1}</Typography>
                  {i == 14 ? <Typography sx={{ color: 'darkgray', fontSize: 30, fontWeight: 'bold', textAlign: 'center', letterSpacing: 2, mt: 2, rotate: '-10deg' }}>CLEAR!</Typography> : ""}
                </Box>
                {StampSheets[i] ?
                  <Box style={{ position: 'absolute', top: 30, left: 10 }}>
                    <Stamp data={{ num: i, color: StampSheets[i].color, date: moment(StampSheets[i].training_day ? StampSheets[i].training_day : StampSheets[i].grant_at).format('M月D日'), content: StampSheets[i].title }} />
                  </Box> : ""}
              </Grid>
            }, this)}

          </Grid>
          <Container style={{ paddingLeft: 30, paddingRight: 30 }} sx={{ mt: 3, mb: 1, p: 3, backgroundColor: 'white' }}>
            <Typography sx={{ fontSize: 20, textAlign: 'left', color: '#357ebd', fontWeight: 'bold' }}>
              過去の提出履歴
            </Typography>
            <TableContainer component={Paper} square elevation={0} align="center" className='list_scroll'>
              <Table aria-label="simple table">
                <TableBody>
                  {stamps.map((row) => (
                    <TableRow key={row.id}>
                      <TableCell sx={{ border: 1, p: 0.5 }}>{moment(row.grant_at).format('YYYY年MM月DD日(ddd)')}</TableCell>
                      <TableCell sx={{ border: 1, p: 0.5 }}>{row.category_title}</TableCell>
                      <TableCell sx={{ border: 1, p: 0.5 }}>{row.title}</TableCell>
                      <TableCell sx={{ width: 25, border: 1, p: 0.5, textAlign: 'center' }}>
                        <IconButton onClick={() => download(row.id)} sx={{ p: 0 }}>
                          <DownloadIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell sx={{ width: 80, border: 1, p: 0.5, textAlign: 'center' }}>
                        <ThemeProvider theme={theme}>
                          <Button color="neutral" variant="contained" size='small' onClick={() => deletestamp(row.id)}>削除</Button>
                        </ThemeProvider>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Container>
        </Grid>
      </Grid>
    </Box>
  );
};

export default StampPut;
